import type { IconVariants } from '@uikit/components/Icon/interfaces';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { copyToClipboard } from '../../helpers/copyToClipboard';
import Icon from '../Icon/Icon';
import type { ShareOptionProps } from './interfaces';
import { getShareOptionsInfo } from './optionsInfo';
import styles from './ShareOption.module.scss';

const ShareOption = ({ variant, text }: ShareOptionProps) => {
  const [url, setUrl] = useState<string>('');
  const currentOption = getShareOptionsInfo(variant, url, text);
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [icon, setIcon] = useState<IconVariants>(currentOption.icon);

  const Tag = variant === 'linkCopy' ? 'div' : 'a';

  const handleClick = () => {
    setIsClicked(true);
    setIcon('action/checkmark');

    if (variant === 'linkCopy') {
      copyToClipboard(url);
    }

    setTimeout(() => {
      setIsClicked(() => false);
      setIcon(() => currentOption.icon);
    }, 3000);
  };

  useEffect(() => {
    if (window) {
      setUrl(() => window.location.href);
    }
  }, []);

  return (
    <Tag
      className={clsx(styles.base, { [styles.clicked]: isClicked })}
      onClick={handleClick}
      href={currentOption?.shareLink}
      target="_blank"
      rel="noreferrer"
    >
      <Icon variant={icon} className={styles.icon} size="iconSize32" />
      <span className={styles.title}>
        {isClicked
          ? (currentOption.clickedName ?? currentOption.name)
          : currentOption.name}
      </span>
    </Tag>
  );
};

export default ShareOption;
